import { atom } from 'jotai';

const initialOrder = {
    customerEmail: "",
    customerFirstName: "",
    customerLastName: "",
    companyName: "",
    companyNip: "",
    city: "",
    postcode: "",
    address: "",
    needInvoice: false,
    acceptedTerms: false,
    productId: "",
    promoCode: null,
};
export const showProformaAtom = atom(false);
export const isLoadingAtom = atom(true);
export const showAlertAtom = atom(false);
export const alertMessageAtom = atom("");
export const productAtom = atom({});
export const orderAtom = atom(initialOrder);


export const hasPasswordFieldFocusAtom = atom(false);